import { useTextes } from '@common/config';
import { Z_TEXT } from '../primitives';

const t = useTextes('Commun', 'Formulaire');

export const Z_FIRST_NAME = Z_TEXT(t['ADM_MES4'])
  .min(2, { error: 'Le Prénom doit être composé d\'au moins 2 caractères.' })
  .regex(/^\p{L}[\p{L}\p{M}\-'’"\s]+$/u, { error: 'Le Prénom ne doit pas contenir de chiffres.' })
  .max(200);

export const FIRST_NAME_PLACEHOLDER = 'Thomas';